/* istanbul ignore next */
/* Code coverage having problems with no statements in classes */
export class SkyTextExpandModalContext {
  public header: string;
  public text: string;
}
